import { render, staticRenderFns } from "./ServicosAutorizados.vue?vue&type=template&id=57518c12"
import script from "./ServicosAutorizados.vue?vue&type=script&lang=js"
export * from "./ServicosAutorizados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports